export const getInitials = (name) => {
  const [firstName, lastName] = name.split(' ');
  return `${firstName.charAt(0)}${lastName.charAt(0)}`;
};
